import { AnalyticsEventName, reportUsage } from '@ms/yammer-data/dist/telemetry';
import { useTranslations } from '@ms/yammer-i18n-react';
import NavigationStrings from '@ms/yammer-strings/dist/Navigation';
import { feedPageUrl } from '@ms/yammer-web-support/dist/urls';
import { useCallback, useMemo } from 'react';

import { usePageUrlClick } from '../../../navigation/SubHeader/hooks/usePageUrlClick';
import { VivaEngageNavigationHeaderPivotItem } from '../types';

type UseHomePivotItem = () => VivaEngageNavigationHeaderPivotItem;
export const useHomePivotItem: UseHomePivotItem = () => {
  const t = useTranslations(NavigationStrings);
  const onPageUrlClick = usePageUrlClick();
  const reportAndRedirectToFeedPage = useCallback(() => {
    reportUsage({
      eventName: AnalyticsEventName.HomeTabClicked,
    });
    onPageUrlClick(feedPageUrl);
  }, [onPageUrlClick]);

  return useMemo(
    () => ({
      key: feedPageUrl,
      onClick: reportAndRedirectToFeedPage,
      text: t.appNavigationHome(),
    }),
    [reportAndRedirectToFeedPage, t]
  );
};
